import { render, staticRenderFns } from "./SubscriptionRedirect.vue?vue&type=template&id=71ef2270&scoped=true&"
import script from "./SubscriptionRedirect.vue?vue&type=script&lang=js&"
export * from "./SubscriptionRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ef2270",
  null
  
)

export default component.exports